"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.budgetApiClient = void 0;
require("@redbox-ruby/data-lib");
const data_lib_1 = require("@redbox-ruby/data-lib");
function budgetApiClient(networkClient) {
    const listActiveBudgetPlans = async (params, query, config) => {
        return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans/active`, query, config);
    };
    return {
        forceBudgetAllocation: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/allocations`, body);
        },
        listTeamBudgetAllocations: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/allocations`, query, config);
        },
        listBudgetAllocations: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/allocations`, query, config);
        },
        getBudgetAllocation: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/allocations/${params.allocationId}`);
        },
        listOrders: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.id}/orders`, query, config);
        },
        getOrder: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/${params.orderId}`);
        },
        createPrepayOrder: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders`, body);
        },
        updatePrepayOrder: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/${params.orderId}`, body);
        },
        deletePrepayOrder: async (params) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/${params.orderId}`);
        },
        deleteArrearsOrder: async (params) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/arrears/${params.orderId}`);
        },
        redeemArrearsVoucher: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.id}/vouchers/redeem`, body);
        },
        listTeamBudgetPlans: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/plans`, query, config);
        },
        listBudgetPlans: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans`, query, config);
        },
        getBudgetPlan: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans/${params.planId}`);
        },
        getLastBudgetPlan: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans/last`);
        },
        getActiveBudgetPlan: async (params, query) => {
            const r = await listActiveBudgetPlans(params, query, {
                all: true,
            });
            if (r.results.length === 0) {
                throw new Error("No active budgets plan found");
            }
            else if (r.results.length > 1) {
                throw new Error("Multiple active budgets plan found");
            }
            return r.results[0];
        },
        listActiveBudgetPlans,
        createBudgetPlan: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans`, body);
        },
        updateBudgetPlan: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans/${params.planId}`, body);
        },
        deleteBudgetPlan: async (params) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/plans/${params.planId}`);
        },
        getCurrentFund: async (params, query) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/fund`, query);
        },
        listTransactions: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/transactions`, query, config);
        },
        getTransaction: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/transactions/${params.transactionId}`);
        },
        addTransaction: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/channels/transactions`, body);
        },
        setTeamStripeCustomer: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.id}/processors/stripe/customer`, body);
        },
        getTeamStripeCustomer: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.id}/processors/stripe/customer`);
        },
        listVoucherDefinitions: async (query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/definitions`, query, config);
        },
        getVoucherDefinition: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/definitions/${params.id}`);
        },
        createVoucherDefinition: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/definitions`, body);
        },
        updateVoucherDefinition: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/definitions/${params.id}`, body);
        },
        deleteVoucherDefinition: async (params) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/definitions/${params.id}`);
        },
        listVoucherCodes: async (query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/codes`, query, config);
        },
        getVoucherCode: async (params) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/codes/${params.id}`);
        },
        createVoucherCode: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/codes`, body);
        },
        updateVoucherCode: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/codes/${params.id}`, body);
        },
        deleteVoucherCode: async (params) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/codes/${params.id}`);
        },
        isVoucherCodeRedeemable: async (query) => {
            return networkClient.getHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/vouchers/redemption`, query);
        },
        createStripePaymentMethod: async (params, body = {}) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/processors/stripe/payment-methods`, body);
        },
        setDefaultStripePaymentMethod: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/processors/stripe/payment-methods/default`, body);
        },
        deleteStripePaymentMethod: async (params, body) => {
            return networkClient.deleteHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/processors/stripe/payment-methods`, body);
        },
        listStripePaymentMethod: (params, query, config) => {
            return networkClient.listHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/processors/stripe/payment-methods`, query, config);
        },
        payPrepayOrderWithStripe: (params) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/${params.orderId}/pay`, {});
        },
        runBudgetManager: async (params) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/campaigns/${params.campaignId}/allocations/manage`, {});
        },
        forceCreateOrUpdateDraftInvoice: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/api/v2/budgets/teams/${params.teamId}/orders/arrears/force-update`, body);
        },
    };
}
exports.budgetApiClient = budgetApiClient;
